// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Default (desktop / tablet) */
.toolsGridIcon {
  width: 88%;
  height: auto;
  margin-bottom: 6px;
}


/* Mobile: reduce icon size by ~40% */
@media (max-width: 550px) {
  .toolsGridIcon {
    width: 124px; /* ~40% smaller than 96px */
    margin-bottom: 4px;
  }
}

@media (max-width: 550px) {
  .toolsGrid h3 {
    font-size: 1rem;
  }

  .toolsGrid p {
    font-size: 1.0rem;
  }
}

.tool-page {
  justify-items: center;
}

form {
  margin-top: 0px;
}`, "",{"version":3,"sources":["webpack://./src/assets/stylesheets/ToolsGrid.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;;AAGA,qCAAqC;AACrC;EACE;IACE,YAAY,EAAE,2BAA2B;IACzC,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Default (desktop / tablet) */\n.toolsGridIcon {\n  width: 88%;\n  height: auto;\n  margin-bottom: 6px;\n}\n\n\n/* Mobile: reduce icon size by ~40% */\n@media (max-width: 550px) {\n  .toolsGridIcon {\n    width: 124px; /* ~40% smaller than 96px */\n    margin-bottom: 4px;\n  }\n}\n\n@media (max-width: 550px) {\n  .toolsGrid h3 {\n    font-size: 1rem;\n  }\n\n  .toolsGrid p {\n    font-size: 1.0rem;\n  }\n}\n\n.tool-page {\n  justify-items: center;\n}\n\nform {\n  margin-top: 0px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
